module.exports = __webpack_public_path__ + "img/role-cancel-confirm.48c66d1e.svg";